<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-8 col-md-12 col-2 mb-3">
                            <h2>Date Setting </h2>
                        </div>
                        <div class="col-lg-4 col-6 text-right">
                            <form class="form-inline justify-content-end">
                                <div class="form-group mb-2 right">
                                    <label for="staticEmail2" class="col-form-label mr-2 text-white">Year: </label>
                                     <select v-model="selectedYear" @change="changeYear()" class="form-control w100p" aria-label="Default select example">
                                        <option v-for="year in years" :key="year">{{year}}</option>
                                    </select>   
                                    <!-- <datepicker v-model="fromDate" placeholder="MM/DD/YYYY"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>    -->
                                </div>
                                </form>
                               
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                        <table class="table invt align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort col-md-6"
                                    >Month</th>
                                <th 
                                    scope="col" 
                                    class="sort text-left col-md-2"
                                    >Start Date</th>    
                               <th 
                                    scope="col" 
                                    class="sort text-left col-md-2"
                                   >End Date</th>      
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                                
                            <tr v-for="data in dateSettings" :key="data.month" >
                                <td class="text-primary">{{data.month}}</td>
                                <td><datepicker v-model="data.startDate" :open-date="data.openDate" placeholder="MM/DD/YYYY"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker></td>
                                <td><datepicker v-model="data.endDate" :open-date="data.openDate" placeholder="MM/DD/YYYY"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker></td>
                                <td class=" text-center">
                                    <div class="d-inline-flex"> 
                                        <a  @click="saveDate(data)" title="SAVE" class="btn ibtn grn"><i class="fas fa-save"></i></a>
                                    </div>  
                                </td>
                            </tr>    
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "ImsProfitLossDateSetting.vue",
   components: {
    Datepicker
  },
  data() {
    return {
      dateSettings : [],
      years : [],
      loading : false,
      selectedYear : new Date().getFullYear()
    };
  },
  methods: {
      changeYear(){
        this.getMonthsInYear();
        this.getMonthSetting()
      },
      getMonthSetting(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .get(config.baseUrlBidSide + 
            "/pnl/month-settings-list?year="+this.selectedYear,
            auth
        )
        .then((result) => {
            this.setMonthlyDate(result.data)
            this.loading = false;                           
        })
        .catch(() => {
            this.loading = false;              
        }); 
      },
      setMonthlyDate(savedSetting){
         this.dateSettings.forEach((monthData) => {
            let obj = savedSetting.find(res => res.month == monthData.month);
            if(obj){
                monthData.startDate = obj.startDate;
                monthData.endDate = obj.endDate;
                monthData.isAdd = false;
                monthData.id = obj.id;
            }else{
                monthData.isAdd = true;
            }
         });
      },
      saveDate(data){
        if(this.checkValid(data)){
            if(data.isAdd){
                this.addDateSetting(data);
            }else{
                this.updateSetting(data);

            }      
        }          
      },
      addDateSetting(data){
        this.loading = true;
        var addData ={
            "year": this.selectedYear,
            "month": data.month,
            "startDate": this.moment(data.startDate).format("YYYY-MM-DD"),
            "endDate": this.moment(data.endDate).format("YYYY-MM-DD")
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .post(config.baseUrlBidSide + "/pnl/month-setting", addData, auth)
        .then(() => {
            this.loading = false;              
            this.getMonthSetting(); 
            this.$alert("Date updated","","success");              
        })
        .catch(() => {
            this.loading = false;              
        });       

      },
      updateSetting(data){
        this.loading = true;
        var updateData ={
            "id" : data.id,
            "year": this.selectedYear,
            "month": data.month,
            "startDate": this.moment(data.startDate).format("YYYY-MM-DD"),
            "endDate": this.moment(data.endDate).format("YYYY-MM-DD")
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .put(config.baseUrlBidSide + "/pnl/month-setting", updateData, auth)
        .then(() => {
            this.loading = false;              
            this.getMonthSetting();   
            this.$alert("Date updated","","success");              

        })
        .catch(() => {
            this.loading = false;              
        }); 
      },
      checkValid(data){
        if(!data.startDate || !data.endDate){
           this.$alert("Start date and end date is required","","warning");
           return false;
        }
        // var selectedStartDateMonth = this.moment(data.startDate).format("MMMM");
        // var selectedEndDateMonth = this.moment(data.endDate).format("MMMM");
        // var selectedStartDateYear = this.moment(data.startDate).format("YYYY");
        // var selectedEndDateYear = this.moment(data.startDate).format("YYYY");
        //console.log(selectedStartDateMonth,selectedEndDateMonth,selectedStartDateYear)
        // if(selectedStartDateMonth != data.month){
        //     var msg1 = "Please select start date and end date in "+ data.month +" month";
        //     this.$alert(msg1,"","warning");
        //    return false;
        // }
        // if(selectedEndDateMonth != data.month  ){
        //     var msg2 = "Please select start date and end date in "+ data.month +" month";
        //     this.$alert(msg2,"","warning");
        //    return false;
        // }
        // if(selectedStartDateYear != this.selectedYear  ){
        //     var msg3 = "Please select start date and end date in "+this.selectedYear +" year";
        //     this.$alert(msg3,"","warning");
        //    return false;
        // }
        // if(selectedEndDateYear != this.selectedYear  ){
        //     var msg4 = "Please select start date and end date in "+this.selectedYear +" year";
        //     this.$alert(msg4,"","warning");
        //    return false;
        // }
        if(this.moment(data.startDate).isAfter(data.endDate)){
            var msg5 = "End date cannot be before start date.";
            this.$alert(msg5,"","warning");
            return false;
        }
        return true;
      },
      getYears(){
        let currentYear = new Date().getFullYear() + 1;
        for (var i = currentYear; i > currentYear - 10; i--) {
                this.years.push(i);   
        }
      },
      getMonthsInYear(){
        let months = this.moment.months();
        this.dateSettings = [];
        months.forEach((month,index) => {
            let data = {};
            data.month = month;
            data.startDate = null;
            data.endDate = null;
            data.openDate = this.moment().set('month', index).set('year', this.selectedYear).toDate();
            //console.log(this.moment().set('month', index).set('year', this.selectedYear).toDate())
            this.dateSettings.push(data)
        });
      }
    
  },
  mounted() {
   this.getMonthSetting();
   this.getYears();
   this.getMonthsInYear();
  }
};
</script>